import { render, staticRenderFns } from "./local_time.vue?vue&type=template&id=9bbb4a00&"
import script from "./local_time.vue?vue&type=script&lang=ts&"
export * from "./local_time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports